<template>
  <span
    class="time-off-request-bamboo-hr-badge time-off-request-bamboo-hr-badge--calendar"
    data-testid="time-off-hris-imported-badge"
    aria-hidden="true"
  >
    <img
      :src="badgeImage"
      alt=""
      class="time-off-request-bamboo-hr-badge__img"
      aria-hidden="true"
    >
  </span>
</template>

<script>
import { hrisImportedBadgeImage } from '~/utils/hris_provider_utils';

export default {
  name: 'TimeOffHrisImportedBadge',
  props: {
    integrationType: {
      type: String,
      required: true,
    },
  },
  computed: {
    badgeImage() {
      return hrisImportedBadgeImage(this.integrationType);
    },
  },
};
</script>
